import React, { useEffect, useState } from 'react';
import {
  Container,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Page from 'src/components/Page';
import Header from './Header';
import { useDispatch, useSelector } from 'react-redux';
import MperitoCard from 'src/components/MperitoCard';
import Results from './Results';

import { fetchIssues } from 'src/actions/issuesActions';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: 100
  }
}));

function IssuesListView() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [issues, setIssues] = useState([]);

  const businessInfo = useSelector((state) => state?.app?.businessInfo);
  const customerId = businessInfo?.customerId;



  useEffect(() => {
    const fetchData = async () => {
      try {
        const issuesList = await dispatch(fetchIssues(customerId));
        setIssues(issuesList || []); // fallback to [] to avoid undefined errors
      } catch (error) {
        console.error("Error fetching issues:", error);
        setIssues([]); // optional: handle fallback
      }
    };

    if (customerId) {
      fetchData();
    }
  }, [customerId]);



  return (
    <Page
      className={classes.root}
      title="Issues List"
    >
      <Container maxWidth={false}>
        <Header />
        <br />
        <br />
        <MperitoCard title={`Issues List ( ${businessInfo?.businessName} - ${businessInfo?.customerId} )`}>
          <Results issuesList={issues} businessInfo={businessInfo} />
        </MperitoCard>
      </Container>
    </Page>
  );
}

export default IssuesListView;

